import { useRecoilValue } from 'recoil'
import healthClaimFormAtom from '@/recoil/healthClaimForm'
import { HealthClaimModeEnum } from '@/constant/E_CLAIM'
import { useGetBanks } from '@/services/healthClaim/useGetBanks'

const BankSelectHook = () => {
  const getBanks = useGetBanks()
  const healthClaim = useRecoilValue(healthClaimFormAtom)
  const isCreateOrEditMode =
    healthClaim.mode === HealthClaimModeEnum.CREATE || healthClaim.mode === HealthClaimModeEnum.EDIT

  return {
    getBanks,
    isCreateOrEditMode,
  }
}

export default BankSelectHook
